import * as swcHelpers from '@swc/helpers';
import { useDispatchTrackEvent, useTealiumEventProperties } from '@grandvisionhq/svc-tealium/events';

const useNewsletterSubmit = (subscribeNewsletter)=>{
    const dispatchTrackEvent = useDispatchTrackEvent();
    const { getCommonUserProperties  } = useTealiumEventProperties();
    const handleNewsletterSignupSuccessTealium = function() {
        var _ref = swcHelpers.asyncToGenerator(function*() {
            try {
                const commonUserProperties = yield getCommonUserProperties();
                dispatchTrackEvent(()=>Promise.resolve(swcHelpers.objectSpread({
                        id: 'Event'
                    }, commonUserProperties))
                );
            } catch (error) {
                console.error('Failed to hash email:', error);
            }
        });
        return function handleNewsletterSignupSuccessTealium() {
            return _ref.apply(this, arguments);
        };
    }();
    const onSubmit = function() {
        var _ref = swcHelpers.asyncToGenerator(function*({ email , firstName , lastName , mandateText  }) {
            try {
                const { data  } = yield subscribeNewsletter({
                    variables: {
                        input: {
                            email,
                            firstName,
                            lastName,
                            mandateText,
                            uiType: 'checkbox',
                            value: true
                        }
                    }
                });
                if (data === null || data === void 0 ? void 0 : data.subscribeNewsletter.success) {
                    handleNewsletterSignupSuccessTealium();
                }
            } catch (error) {
                console.error('Newsletter subscription failed:', error);
            }
        });
        return function onSubmit(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        onSubmit
    };
};

export { useNewsletterSubmit };
//# sourceMappingURL=use-newsletter-submit.js.map
